import MeEventosRotas from './meeventos/MeEventosRotas'

export default {
    path: 'integracoes',
    name: 'Integracoes',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        MeEventosRotas
    ]
}
